<!--
 * @Descripttion: 直播间按钮
 * @version: 
 * @Author: Jeson
 * @Date: 2021-08-24 11:28:18
 * @LastEditors: Jeson
 * @LastEditTime: 2021-09-02 17:05:16
-->
<template>
    <div>
        <div class="back-home" @click="openLive()" >
            <div class="img_div"><img :src="liveRoomImg" /></div>
            <div class="name_div">{{IsReview?'回播中':'直播中'}}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        LiveRoomUrl: {
            type: String, default: ''
        },
        IsReview:{
            type:Boolean,default:false
        }
    },
    data() {
        return {
            // 直播
            flags: false,
            position: {
                x: 0,
                y: 0,
            },
            nx: "",
            ny: "",
            dx: "",
            dy: "",
            xPum: "",
            yPum: "",
            isShow: false,
            moveBtn: {},
            liveRoomImg: require("@/assets/liveroom.gif"),
        }
    },
    created() {

    },
    mounted() {
        // 直播
        this.moveBtn = this.$refs.moveBtn;
    },
    methods: {      
        openLive() {
            window.open(this.LiveRoomUrl, '_blank')
        }
    }
}
</script>

<style lang="less" scoped>
.back-home {
    margin-top: -0.7rem;
    margin-left: 20px;
    width: 60px;
    height: 70px;
    background: linear-gradient(176deg, #6babff 0%, #0f6eea 100%);
    border-radius:8px;
    text-align: center;
    line-height: 50px;
    position: relative;
    .img_div{
        position: absolute;
        img{
            width: 65%;
            height: 650%;
        }        
    }
    .name_div{
        color: white;
        position: absolute;
        width: 100%;
        top: 30px;
        bottom: 0px;        
        font-size: 0.24rem;
    }
}
</style>